/// <reference path="../_all.ts" />

module library {
  'use strict';

  export interface IUrlEncodeFilter extends ng.IFilterService {
      (name: 'urlencode'): <T>(input : T[], key : string) => T[];
  }

  UrlEncodeFilter.$inject = [];
  export function UrlEncodeFilter() {

     return function(input : string) : string { 
       if (!input) return "";
        return encodeURIComponent(input); 
     }
  }
}